import React from 'react'
import {Size} from '../types';
import styled from 'styled-components';
import {scrollBarStyling} from '../styles';

const Wrapper = styled.div`
  flex: 1;
  margin: 8px;
  overflow: auto;
  box-sizing: border-box;

  &.small {
    padding: 0 8px;
  }

  &.medium {
    padding: 0 12px;
  }

  &.large {
    padding: 0 16px;
  }

  ${scrollBarStyling(Size.Small)}
`;

const TileBody: React.FunctionComponent<{ size: Size; children?: React.ReactNode; }> = ({children, size}) => {


  return (
    <Wrapper className={size}>
      {children}
    </Wrapper>
  )
}


export default TileBody;
